export default __webpack_public_path__ + "static/media/safari-phone-2.83f9d6fb.png";